import { accountIsOrganization, getPaymentPlanCategory, } from "@buildwithflux/models";
import { getAccountDisplayName, getAccountType } from "../account";
/**
 * Looking for a tracking event name for accounts? Try to use either organizations or users
 */
/**
 * These are the valid actions for several event types that are common to users and organizations
 *
 * Use e.g. keyof typeof trackingEventActionsForAccounts when typing against this
 */
export const trackingEventActionsForAccounts = {
    followPricingLink: "followPricingLink",
    followCopilotCreditsLink: "followCopilotCreditsLink",
    clickPlansAndPaymentsDialogButton: "clickPlansAndPaymentsDialogButton",
    setSpendingLimit: "setSpendingLimit",
    showChooseYourPlanDialog: "showChooseYourPlanDialog",
    showRestoreProjectDialog: "showRestoreProjectDialog",
    clickContactEnterpriseSales: "clickContactEnterpriseSales",
    upgradeToPro: "upgradeToPro",
    getStarter: "getStarter",
    getPro: "getPro",
    paymentSuccess: "paymentSuccess",
    paidCopilotCreditsFirstTimeInformationDialogButton: "paidCopilotCreditsFirstTimeInformationDialogButton",
    trialReactivated: "trialReactivated",
    cancelPlan: "cancelPlan",
};
export function trackingEventParametersForAccount(account) {
    return {
        content_id: account.uid,
        display_name: getAccountDisplayName(account),
        organization_handle: accountIsOrganization(account) ? account.handle : undefined,
        ownerType: getAccountType(account),
        plan: getPaymentPlanCategory(account),
    };
}
//# sourceMappingURL=accounts.js.map